export class BaseObject{
	load(obj) {
		let keys = Object.keys(this);
		for (let i = 0; i < keys.length; i++) {
			let key = keys[i];
			if(this.hasOwnProperty(key) && obj.hasOwnProperty(key)) {
				this[key] = obj[key];
			}
		}
		return this;
	}
}

export class BaseEntity extends BaseObject {
	constructor() {
		super();
	}
}

export class BaseSearch {
    page     = 1;
    pageSize = 20;
    sort     = "-id";
    toParams() {
        return {
            sort: this.sort,
            page: this.page,
            page_size: this.pageSize,
        };
    }
}

export const NormalizeMobile = (mobile) => {
    if (mobile == null) {
        return "无";
    }
    let value = mobile.toString().trim();
    return value.length > 0 ? value : "无";
};

export const NormalizeEmail = (email) => {
    if (email == null) {
        return "null";
    }
    let value = email.toString().trim();
    return value.length > 0 ? value : "null";
};

export const NormalizeChannel = (channel) => {
    if (channel == null) {
        return "normal";
    }
    let value = channel.toString().trim();
    return value.length > 0 ? value : "normal";
};

export const NormalizeChannelName = (channelName) => {
    if (channelName == null) {
        return "normal";
    }
    let value = channelName.toString().trim();
    return value.length > 0 ? value : "normal";
};

export class StatusCount {
    //object : {statusKey: count} : {1: 5, 2: 10}
    initByData(object) {
        for (const key in object) {
            if (Object.hasOwnProperty.call(object, key)) {
                this[key] = object[key];
            }
        }
    }
}

export class BaseList extends BaseObject {
    list   = [];
    total  = 0;
    search = new BaseSearch(); // instance of BaseSearch
    constructor(search) {
		super();
		this.search = search;
	}
}
